// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d84f2124","732":"3208eb07","977":"ca590d4c"}[chunkId] + ".chunk.js";
};